'use client';

import styled from '@emotion/styled';
import { ContentWrap, Css, Responsive } from '@/ui';
import { theme } from '../../../styles/theme';
import { getHeadingStyle } from '../../../styles/utils/getHeadingStyle';

export const HomeSection = styled(ContentWrap.withComponent('section'))`
	padding: ${Css.pxToRemFromTheme(20)} 0 ${Css.pxToRemFromTheme(20)};
`;

export const HomeSubtitle = styled.div`
	font-size: ${Css.pxToRemFromTheme(12)};
	text-transform: uppercase;
`;

export const HomeTitle = styled.h2`
	line-height: normal;
	margin-bottom: 0;

	${getHeadingStyle(theme, 'h3')}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: ${Css.pxToRemFromTheme(30)};
	}
`;
